const PERFIL_CLIENTE = "CLI";
const PERFIL_ADMININSTRADOR = "ADM";
const PERFIL_AUDITOR = "AUD";
const PERFIL_FORNECEDOR = "FOR";
const PERFIL_FORNECEDOR_AGV = "FGV";
const PERFIL_GESTOR_API= "API";
const PERFIL_GESTOR_AGV= "AGV";
const PERFIL_OPERADOR= "OPE";
const PERFIL_PONTO_FOCAL= "PFC";
const PERFIL_MANTENEDOR= "MAN";
const PERFIL_ANONIMO= "ANO";

export {PERFIL_CLIENTE, PERFIL_ADMININSTRADOR, PERFIL_AUDITOR, PERFIL_FORNECEDOR, PERFIL_FORNECEDOR_AGV, PERFIL_GESTOR_API, PERFIL_GESTOR_AGV, PERFIL_OPERADOR, PERFIL_MANTENEDOR, PERFIL_ANONIMO, PERFIL_PONTO_FOCAL}